import { render, staticRenderFns } from "./FileMenu.vue?vue&type=template&id=64c9db05&scoped=true"
import script from "./FileMenu.vue?vue&type=script&lang=js"
export * from "./FileMenu.vue?vue&type=script&lang=js"
import style0 from "./FileMenu.vue?vue&type=style&index=0&id=64c9db05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9db05",
  null
  
)

export default component.exports